module.exports = __webpack_public_path__ + "img/private-napolimania-fish-1.04381615.jpg";